import API from './api';
import router from '@/router';

export default {
  fetchCoordinatorCount() {
    return API().get('coordinators-count');
  },
  fetchCoordinatorsExport() {
    return API().get('coordinators');
  },
  fetchCoordinators(currentPage, perPage) {
    return API().get('table/coordinators', {
      params: {
        currentPage,
        perPage,
      },
    });
  },
  fetchClusterCoordinators(id,currentPage, perPage) {
    return API().get(`table/coordinators/${id}`, {
      params: {
        currentPage,
        perPage,
      },
    });
  },
  fetchCoordinatorNames() {
    return API().get('coordinators/names');
  },
  addCoordinator(user, coordinator) {
    return API().post('coordinators', { user, coordinator });
  },
  updateCoordinator(params) {
    return API().put(`coordinators/${router.currentRoute.params.id}`, params);
  },
  getCoordinator() {
    return API().get(`coordinators/${router.currentRoute.params.id}`);
  },
  updateCoordinatorActive(params) {
    return API().put(`coordinators/${params.uuid}`, params);
  },
  fetchCoordinatorTrainers() {
    return API().get(`coordinators/${router.currentRoute.params.id}/trainers`);
  },
  fetchCoordinatorTeams() {
    return API().get(`coordinators/${router.currentRoute.params.id}/teams`);
  },
  fetchCoordinatorSchools() {
    return API().get(`coordinators/${router.currentRoute.params.id}/schools`);
  },
  addCoordinatorSchool(params) {
    console.log(params);
    console.log(router.currentRoute.params.id);
    return API().post(
      `coordinators/${router.currentRoute.params.id}/schools`,
      params
    );
  },
  updateCoordinatorSchool(params) {
    return API().put(
      `coordinators/${router.currentRoute.params.id}/schools`,
      params
    );
  },
  deleteCoordinatorSchool(params) {
    return API().delete(
      `coordinators/${router.currentRoute.params.id}/schools/${params.id}`
    );
  },
  fetchCoordinatorTeachers() {
    return API().get(`coordinators/${router.currentRoute.params.id}/teachers`);
  },
  fetchCoordinatorSchoolsTeachers() {
    return API().get(
      `coordinators/${router.currentRoute.params.id}/schools/teachers`
    );
  },
  addCoordinatorTeacher(params) {
    return API().post(
      `coordinators/${router.currentRoute.params.id}/teachers`,
      params
    );
  },
  updateCoordinatorTeacher(params) {
    const coordinatorTeacherId = params.teacher_uuid;
    return API().put(
      `coordinators/${router.currentRoute.params.id}/teachers/${coordinatorTeacherId}`,
      params
    );
  },
  deleteCoordinatorTeacher(params) {
    return API().delete(
      `coordinators/${router.currentRoute.params.id}/teachers/${params.uuid}`
    );
  },
  fetchCoordinatorGroups() {
    return API().get(`coordinators/${router.currentRoute.params.id}/groups`);
  },
  fetchCoordinatorObservations() {
    return API().get(`coordinators/${router.currentRoute.params.id}/observations`);
  },
  addCoordinatorObservation(params) {
    return API().post('coordinators/observations', params);
  },
  updateCoordinatorObservation(params) {
    return API().put(
      `coordinators/${router.currentRoute.params.id}/observations`,
      params
    );
  },
  deleteCoordinatorObservation(coordinatorObservationId) {
    return API().delete(
      `coordinators/${router.currentRoute.params.id}/observations`,
      coordinatorObservationId
    );
  },
  fetchSchoolNamesByCoordinator() {
    return API().get(`coordinators/${router.currentRoute.params.id}/school-names`);
  },
  fetchTeacherNamesByCoordinatorSchool(id) {
    return API().get(`schools/${id}/teacher-names`);
  },
  fetchCoordinatorTeacherWorkshops() {
    return API().get(
      `coordinators/${router.currentRoute.params.id}/teacher-workshops`
    );
  },
  fetchOneCoordinatorTeacherWorkshop(id) {
    return API().get(
      `coordinators/${router.currentRoute.params.id}/teacher-workshops/${id}`
    );
  },
  addCoordinatorTeacherWorkshop(params) {
    return API().post(
      `coordinators/${router.currentRoute.params.id}/teacher-workshops`,
      params
    );
  },
  updateCoordinatorTeacherWorkshop(params) {
    const coordinatorTeacherId = params.id;
    return API().put(
      `coordinators/${router.currentRoute.params.id}/teacher-workshops/${coordinatorTeacherId}`,
      params
    );
  },
  deleteCoordinatorTeacherWorkshop(params) {
    return API().delete(
      `coordinators/${router.currentRoute.params.id}/teacher-workshops/${params.id}`
    );
  },
  fetchCoordinatorModules() {
    return API().get(`coordinators/${router.currentRoute.params.id}/modules`);
  },
  fetchOneCoordinatorModule(id) {
    return API().get(`coordinators/${router.currentRoute.params.id}/modules/${id}`);
  },
  addCoordinatorModule(params) {
    return API().post(
      `coordinators/${router.currentRoute.params.id}/modules`,
      params
    );
  },
  updateCoordinatorModule(params) {
    return API().put(
      `coordinators/${router.currentRoute.params.id}/modules/${params.id}`,
      params
    );
  },
  deleteCoordinatorModule(id) {
    return API().delete(
      `coordinators/${router.currentRoute.params.id}/modules/${id}`
    );
  },
};
